import { render, staticRenderFns } from "./ModalDefaultReset.vue?vue&type=template&id=0c0551e9&scoped=true"
import script from "./ModalDefaultReset.vue?vue&type=script&lang=js"
export * from "./ModalDefaultReset.vue?vue&type=script&lang=js"
import style0 from "./ModalDefaultReset.vue?vue&type=style&index=0&id=0c0551e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0551e9",
  null
  
)

export default component.exports